import { useSyncExternalStore } from 'react';

import identity from 'lodash-es/identity';
import isEqual from 'lodash-es/isEqual';
import memoizeOne from 'memoize-one';

import FeatureGates from '@atlaskit/feature-gate-js-client';

const deepMemoized = memoizeOne(identity, isEqual);

const subscribe = (onStoreChange: () => void) => {
  return FeatureGates.onAnyUpdated(() => {
    onStoreChange();
  });
};

const getSnapshot = () => {
  return deepMemoized(FeatureGates.getOverrides().gates);
};

export const useFeatureGateOverrides = () => {
  return useSyncExternalStore(subscribe, getSnapshot);
};

/**
 * These aliases aren't strictly necessary (we could use the `FeatureGates` methods directly in
 * our dev tools components), but they might help make refactoring easier if we decide to change
 * the way we read overrides in the future (like persisting them to the server via a cookie or
 * user preference) in order to support feature gates provided by and/or used in Core or feature
 * gates that are required during SSR.
 */

export const checkGate = (name: string) => {
  return FeatureGates.checkGate(name, { fireGateExposure: false });
};

export const clearAllOverrides = () => {
  return FeatureGates.clearAllOverrides();
};

export const clearGateOverride = (name: string) => {
  return FeatureGates.clearGateOverride(name);
};

export const isGateExists = (name: string) => {
  return FeatureGates.isGateExists(name);
};

export const overrideGate = (name: string, value: boolean) => {
  return FeatureGates.overrideGate(name, value);
};
